export default "Bitte bestätigen!";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/0/approve-help.js